<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="10" class="search-wrapper">
      <el-col :span="5" style="padding-left: 0">
        <div class="grid-content">
          <el-input placeholder="" v-model="orderNo">
            <template slot="prepend">订单号</template>
          </el-input>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="grid-content">
          <el-select v-model="status" clearable placeholder="订单状态" style="width: 100%;">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="grid-content">
          <el-date-picker
            style="width: 100%"
            v-model="startTime"
            type="date"
            placeholder="订单开始时间">
          </el-date-picker>
        </div>
      </el-col>
      <el-col :span="1" style="height: 40px; padding-left: 0">
        <div class="grid-content" style="height: 40px; line-height: 40px; text-align: center">—</div>
      </el-col>
      <el-col :span="5" style="padding-left: 0">
        <div class="grid-content">
          <el-date-picker
            style="width: 100%"
            v-model="endTime"
            type="date"
            placeholder="订单结束时间">
          </el-date-picker>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="search-wrapper">
      <el-col :span="5" style="padding-left: 0">
        <div class="grid-content">
          <el-select v-model="schoolId" clearable placeholder="学校名称" style="width: 100%;">
            <el-option
              v-for="item in schoolOptions"
              :key="item.uuid"
              :label="item.schoolName"
              :value="item.uuid">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="grid-content">
          <el-input placeholder="" v-model="insNo">
            <template slot="prepend">教练证件号</template>
          </el-input>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="grid-content">
          <el-input placeholder="" v-model="insName">
            <template slot="prepend">教练姓名</template>
          </el-input>
        </div>
      </el-col>
      <el-col :span="3">&nbsp;</el-col>
      <el-col :span="3">
        <div class="grid-content">
          <el-button
            style="width: 100%;"
            type="primary"
            @click="search"
          >查询
          </el-button>
        </div>
      </el-col>
    </el-row>
    <el-table
      class="table"
      :data="orderList"
      :max-height="tableHeight"
      style="width: 100%">
      <el-table-column
        fixed="left"
        prop="orderNo"
        label="订单号"
        align="center"
        width="170">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="订单时间"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="statusDesc"
        label="订单状态"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="totalNum"
        label="课程数量"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="totalAmt"
        label="订单总价(元)"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="schoolName"
        label="下单学校"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="userName"
        label="下单用户"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="tradeTypeDesc"
        label="付款方式"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="entryUserName"
        label="最后操作人"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="entryTime"
        label="最后更新时间"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="goToDetail(scope.row)"
          >查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @current-change="handleCurrentChange"
      prev-text="上一页"
      next-text="下一页"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script type="text/ecmascript-6">
  import { listType } from '@/common/js/config';
  import { getOrderList, getSchools } from '@/api/order';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'course_list',
    data() {
      return {
        statusOptions: [{
          value: 0,
          label: '全部'
        }, {
          value: 1,
          label: '待支付'
        }, {
          value: 2,
          label: '待BASI确认'
        }, {
          value: 3,
          label: '支付中'
        }, {
          value: 4,
          label: '待发货'
        }, {
          value: 5,
          label: '已发货'
        }, {
          value: -1,
          label: '交易关闭'
        }],
        status: null,
        orderNo: '',
        startTime: '',
        endTime: '',
        schoolOptions: [],
        schoolId: '',
        insNo: '',
        insName: '',
        currentPage: 1,
        total: 0,
        tableHeight: 500,
        pageSize: 3
      };
    },
    created() {
      this.status = this.$route.query.status ? parseInt(this.$route.query.status) : null;
      this._getSchools();
      if (!this.$route.params.pageNum) {
        this.$router.push('/order_list/1');
        this.currentPage = 1;
        this._getOrderList(1);
      } else {
        this._getOrderList(this.$route.params.pageNum);
        this.currentPage = parseInt(this.$route.params.pageNum);
      }
    },
    mounted() {
      let orderHeight = document.body.clientHeight;
      this.tableHeight = orderHeight - 284;
    },
    methods: {
      search() {
        this.$router.push('/order_list/1');
        this.currentPage = 1;
        this._getOrderList(1);
      },
      goToDetail(order) {
        this.$router.push(`/order_detail/${order.id}`);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.$router.push(`/order_list/${val}`);
        this._getOrderList(val);
      },
      _getSchools() {
        getSchools(this.user.userId).then((res) => {
          this.schoolOptions = res.schools;
        });
      },
      _getOrderList(pageNum) {
        getOrderList(
          this.user.userId,
          pageNum,
          this.status || 0,
          this.orderNo,
          this.startTime,
          this.endTime,
          this.schoolId,
          this.insNo,
          this.insName
        ).then((res) => {
          this.total = res.count;
          this.pageSize = res.pageSize;
          this.setList({
            list: res.orderList,
            type: listType.ORDER
          });
        });
      },
      ...mapActions([
        'setList',
        'setItem'
      ])
    },
    computed: {
      ...mapGetters([
        'orderList',
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    height: 100%;
    overflow: scroll;
    .title
      margin-bottom: 20px;
    .search-wrapper
      margin: 0 0 10px 0 !important;
    .add-btn
      margin-bottom: 10px;
    .pagination
      margin-top: 10px;
</style>